module.exports = __webpack_public_path__ + "img/store_black.fc44497e.svg";